import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class ContactService {
    constructor(private httpService: HttpService) {

    }

    sendContactMessage(details: any): Observable<any> {
        return this.httpService.post('api/contact/send-message', details);
    }
}
